import { logger } from '@vista-digital/occ-domain';
import { TextInputModalActionType as ActionType } from '../types/action-type';
export const textInputModalActionReducer = (state, action) => {
    switch (action.type) {
        case ActionType.SetFormData:
            return Object.assign(Object.assign({}, state), { formData: Object.assign(Object.assign({}, state.formData), action.formData) });
        case ActionType.SetFormSubmittingState:
            return Object.assign(Object.assign({}, state), { isSubmitting: action.isSubmitting });
        default: {
            logger.error(`Unknown TextInputModalAction '${action.type}'.`);
            return state;
        }
    }
};
//# sourceMappingURL=action-reducer.js.map